const lang = {
  notification: {
    title: 'お知らせ',
    content: '2020年9月1日<br>前後写真を同じアングルで撮影ができる<br>『ZENGOカメラ』アプリを無料で提供開始。'
  },
  qa: {
    title: 'よくある質問',
    qa_list: [
      {
        question: '『ZENGOカメラ』アプリで、何ができますか？',
        answer: '『ZENGOカメラ』は前後写真を同じアングルで撮影することができるアプリです。撮影した写真にキャプション登録・編集もできます。'
      },
      {
        question: '『ZENGOカメラ』アプリを使用できる端末は？',
        answer: '『ZENGOカメラ』アプリはiOS専用のアプリケーションです。'
      }
    ]
  },
  term: {
    title: '利用規約',
    content:
      '<p>本利⽤規約は、株式会社ルクレ（以下、当社）が運営する「ZENGOカメラ」サービス（以下、本サービス）について、お客様（以下、ユーザ）の利⽤に関する決まりを定めるものです。</p>' +
      '<p>ユーザは、本サービスを使⽤する前に、下記を必ずお読みください。本サービスを利⽤することにより、本規約の全ての条件に同意したものとみなします。ユーザが本契約の条件に同意できない場合には、本サービスの利⽤を中⽌してください。</p>' +
      '<h3>使用許諾</h3>' +
      '<p>本規約では、当社がユーザに対し、本サービスを利用する際の条件を規定します。当社は、本規約記載の条件に従い本サービスを利用する、非独占的、再許諾不可能かつ譲渡不可能な権利をユーザに対して許諾いたします。</p>' +
      '<p>本サービスには当社の企業秘密およびその他の情報が含まれており、その事実をユーザは十分にご理解いただかなくてはなりません。ユーザは、本サービスのリバースエンジニアリング、逆コンパイル、あるいは逆アセンブルはできず、また、通常の使用では見ることができないような本サービスの情報を取得するためのいかなる行為もすることはできません。ユーザは、本サービスの一部または全部をコピーまたは改変することはできません。本規約に基づくいかなる権利もユーザが第三者に許諾することはできず、また、ユーザの顧客サービス（有償、無償を問わず営利目的または付加価値サービスとして第三者へ提供されるサービス）の一環として本サービスを使用させることはできません。</p>' +
      '<p>ユーザは、本サービスを公序良俗に反する目的ならびに各種法令に抵触する可能性のある目的で使用してはなりません。</p>' +
      '<h3>知的財産権</h3>' +
      '<p>本サービスに関する著作権、特許権、商標権、ノウハウおよびその他のすべての知的財産権は当社ならびに当社のライセンサーに帰属します。</p>' +
      '<h3>保証および責任の限定</h3>' +
      '<p>当社は、本サービスに含まれる機能がユーザの必要条件を満たすこと、サービスの操作に支障がないこと、あるいはエラーの発生がないことを保証するものではありません。本サービスは特定の目的にかなうことや市販性を暗示的に保証することを含めて、明示的もしくは非明示的ないかなる保証も行わず、現状のままで提供されます。</p>' +
      '<p>ユーザは、目的とする結果を達成するための本サービスの選択、インストール、利用、本サービスから得られる結果に対してすべての責任を負うものとします。本サービスの品質および性能のリスクについても、ユーザがすべての面で受諾するものとします。</p>' +
      '<p>ユーザは、ユーザが本サービスを利用し記録した情報をユーザの責任のもと管理、利用するものとします。なお、当該情報についてユーザの責による紛失、誤用および流出等の事故が起こった場合ならびに不適切な利用による紛争が起こった場合においても、当社はその一切の責任を負いません。</p>' +
      '<p>当社がそのような損害の可能性を示唆されていたとしても、当社は本サービスおよび本契約に起因または関連するいかなる損失利益、損失貯蓄、損失収入、損失データに対しても、また間接的損害、偶発的損害、例外的損害、必然的損害に対しても責任を負いません。ただし、法令により本条の規定が認められない場合、当社はユーザに対し、ユーザが当社に対し本サービスの対価として支払った金額を上限として賠償責任を負うものとします。</p>' +
      '<h3>連携サービスの利用</h3>' +
      '<p>ユーザーは、当社が提供する、本サービスに連携させることができるサービス（以下、「連携サービス」といいます。）を利用する場合には、本規約およびその他当社所定の条件のほか、当該連携サービスの定める利用規約その他の条件に従うものとします。</p>' +
      '<h3>ユーザ資格の取消</h3>' +
      '<p>ユーザが本規約のいずれかの条項に違反した場合、当社は事前に通知することなく、ユーザ資格を取り消します。</p>' +
      '<h3>個人情報</h3>' +
      '<p>ユーザ登録情報および当社が取得したユーザに関する個人情報は、別途当社が定める個人情報保護方針（https://lecre.jp/privacy/）に基づき、適切に取り扱われます。本サービスに関して、当社が取得した個人情報の利用目的等については、個人情報の取り扱い（https://●●●　※記載してください）に記載しています。</p>' +
      '<h3 class="mt-40">一般条項</h3>' +
      '<p>本規約は、本サービスの利用に関し、本規約への同意以前にユーザと当社との間になされたすべての取り決めに優先して適用されます。なお、当社は、以下の場合において、ユーザの同意を得ることなく本規約およびその他の告知（以下、本規約等）の内容を変更できるものとし、当該変更がなされた場合、従前の本規約等は無効となり、最新の本規約等が適用されるものとします。</p>' +
      '<p>本規約等の内容の変更が、ユーザの一般の利益に適合するとき。</p>' +
      '<p>本規約等の内容の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき。</p>' +
      '<p>当社は、前項による本契約等の内容の変更にあたり、変更後の本契約等の効力発生日の１か月前までに、本契約等を変更する旨及び変更後の本契約等とその効力発生日を当社ウェブサイト（URL：https://www.lecre.jp）に掲示し、またはユーザに電子メールで通知します。</p>' +
      '<p>本規約は、ユーザおよびユーザの従業員、雇用側、契約者、ならびに代理店等、いかなる後継者または受託者にも義務づけられます。</p>' +
      '<p>本規約は、日本国法に準拠するものとします。本規約に起因する紛争の解決については、東京地方裁判所が第一審としての専属的管轄権を有するものとします。</p>' +
      '<p class="mt-40">2020年7月20日制定</p>' +
      '<p class="mt-20">東京都港区北青山１－２－３　青山ビル３F</p>' +
      '<p>株式会社ルクレ</p>'
  },
  privacy: {
    title: 'アプリケーション・<br>プライバシーポリシー',
    content:
     '<p>『ZENGOカメラ』アプリに関するアプリケーション・プライバシーポリシー</p>' +
     '<h3>第1条.&nbsp;定義</h3>' +
     '<p>このアプリケーション・プライバシーポリシー（以下、本プライバシーポリシーといいます）は、株式会社ルクレ（以下、「当社」といいます）が提供するスマートフォン用アプリケーション『ZENGOカメラ』（以下、本アプリケーションといいます）および本アプリケーションに関するサービス（以下、本サービスといいます）における利用者情報の取扱いを定めたものです。なお、当社の連絡先は、第10条をご覧下さい。</p>' +
     '<h3>第2条.&nbsp;取得される情報の項目、利用目的、取得方法</h3>' +
     '<p>本アプリケーションおよび本サービスのご利用に際して、以下の利用者情報を以下の利用目的のためにアプリケーション経由で取得いたします。</p>' +
     '<p class="mt-20"><b>利用目的：</b>取得する情報の項目</p>' +
     '<p><b>取得方法：</b>コンテンツ（※）作成のため</p>' +
     '<p><b>写真、カメラ：</b>自動取得</p>' +
     '<p><b>テキスト：</b>利用者による入力・お問い合わせ対応（本人への連絡を含む）のため</p>' +
     '<p><b>端末モデル名・OS名・OSバージョン・メールアドレス（※問い合わせ時のメールアドレスのみメーラーによる自動取得）：</b>自動取得</p>' +
     '<p class="mt-20">※「コンテンツ」とは、本サービスにおいてユーザまたは当社により送信、複製、その他の方法により使用される、すべてのテキスト、データ、グラフィック、写真、絵、音声、音楽およびその他の素材をいいます。</p>' +
     '<h3>第3条.&nbsp;同意</h3>' +
     '<p>本アプリケーションおよび本サービスは、本プライバシーポリシーをご確認いただき、内容をご理解したうえでご利用ください。本プライバシーポリシーは本サービスホームページに掲示されており、この掲示をもって公表したものとします。ご利用者は本アプリケーションをインストールする際に、本プライバシーポリシーをご確認ください。</p>' +
     '<h3>第4条.&nbsp;外部送信</h3>' +
     '<p>第2条に基づき取得された情報について、別途、連携サービスを利用する場合には、当社の設置するサーバーに転送され、目的の範囲で使用されます。</p>' +
     '<h3>第5条.&nbsp;情報収集モジュール</h3>' +
     '<p>当社は本アプリケーションおよび本サービス提供や利用に関する動向調査、利用者に適切な広告表示をするために、対象アプリおよび対象サービスの機能とは独立した、第三者による情報収集モジュールを利用します。当社が利用する主な情報収集モジュールは以下の通りです。なお、取得する情報、利用目的、第三者への提供等につきましては、以下に記載されている各社のアプリケーション・プライバシーポリシーのリンクよりご確認ください。</p>' +
     '<p class="mt-25">Firebase SDK</p>' +
     '<p>提供者：Google&nbsp;LLC</p>' +
     '<p>アプリケーション・プライバシーポリシー （※リンク先を表示）</p>' +
     '<p>https://policies.google.com/privacy?hl=ja</p>' +
     '<h3>第6条.&nbsp;利用者関与の方法</h3>' +
     '<p>利用者が、本アプリケーションを端末より削除（アンインストール）した場合、本アプリケーションを通じた利用者情報の取得は直ちに停止されます。</p>' +
     '<h3>第7条.&nbsp;サービスの終了と情報の取扱い</h3>' +
     '<p>本アプリケーションおよび本サービスは、利用者が本アプリケーションを削除した場合、ご利用を終了されたものとします。</p>' +
     '<p>1.利用者が、本アプリケーションの削除（アンインストール）機能を利用して端末より削除（アンインストール）された場合、利用者より取得、保存した利用者情報は全て端末より直ちに削除され、本サービス上のサーバからは適切な管理のもと定期的なメンテナンス時に廃棄されます。</p>' +
     '<p>2.利用者が、本アプリケーションを本アプリケーションの削除（アンインストール）機能を利用せずに端末より削除された場合や端末を交換もしくは廃棄された場合、端末では利用者情報は削除されませんのでご注意ください。</p>' +
     '<h3>第8条.&nbsp;個人情報保護方針（プライバシーポリシー）等へのリンク</h3>' +
     '<p>当社の個人情報保護方針（プライバシーポリシー）および本プライバシーポリシーの最新のものは、下記のリンクよりご確認ください。本個人情報保護方針（プライバシーポリシー）と本プライバシーポリシーが異なる場合には、本プライバシーポリシーが優先するものとします。</p>' +
     '<p class="mt-20">●当社の個人情報保護方針</p>' +
     '<p>https://lecre.jp/privacy/</p>' +
     '<p>●本アプリケーションおよび本サービスの利用規約</p>' +
     '<p>http://www.xxxx.xxxx.co.jp/xxxx/xxxx/&nbsp;（※リンク先を表示）</p>' +
     '<p>●本アプリケーションのアプリケーション・プライバシーポリシー</p>' +
     '<p>http://www.xxxx.xxxx.co.jp/xxxx/xxxx/&nbsp;（※リンク先を表示）</p>' +
     '<h3>第9条.&nbsp;情報の開示、提供</h3>' +
     '<p>当社は、利用者の同意を得ることなく、本アプリケーションおよび本サービスにて利用者より取得、保存した情報を、本プライバシーポリシーに明示している第三者以外に開示または提供することはありません。ただし、以下の場合は除きます。</p>' +
     '<p>1.法令に基づく場合。</p>' +
     '<p>2.人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合。</p>' +
     '<p>3.国の機関もしくは地方公共団体またはその委託を受けたものが、法令の定めにより遂行することに協力する必要がある場合であって、本人の同意を得ることによりその遂行に支障を及ぼすおそれがある場合。</p>' +
     '<p>4.その他、社会通念上、当社が必要と判断した場合であって、本人の同意を得ることが困難である場合。</p>' +
     '<h3>第10条.問い合わせ窓口</h3>' +
     '<p>本アプリケーションおよび本サービスにおける利用者情報の取扱いに関するお問い合わせ、ご相談は以下の窓口でお受けいたします。</p>' +
     '<p>●窓口名称&nbsp;：&nbsp;ZENGOサポート</p>' +
     '<p>●お問い合わせ方法&nbsp;：メール</p>' +
     '<p>●メール：zengo-support@lecre.jp</p>' +
     '<h3>第11条.変更</h3>' +
     '<p>本プライバシーポリシーは改定されることがあります。本アプリケーションのバージョンアップに伴って、利用者情報の取得項目の変更や追加、利用目的の変更、第三者提供等について変更がある場合には、ダウンロード前に通知し、重要なものについてはインストール前もしくはインストール時にあらためて同意を取得させていただきます。</p>' +
     '<p class="mt-50">施行日：2020年7月20日</p>' +
     '<p>株式会社ルクレ</p>'
  },
  information: {
    title: '個人情報の取り扱い',
    content:
    '<h3>1. 事業者の氏名又は名称</h3>' +
    '<p>株式会社ルクレ</p>' +
    '<h3>2. 個人情報保護管理者</h3>' +
    '<p>部署：管理部</p>' +
    '<p>連絡先：TEL：03-4500-6700 E-mail： privacy@lecre.jp</p>' +
    '<h3>3. 個人情報の利用目的</h3>' +
    '<p>●サービスのお申し込み受付と、当該サービスの実施、運営（本人への連絡を含む）のため</p>' +
    '<p>・本サービスの提供のため</p>' +
    '<p>・本サービスに関連した、各種情報のご案内のため</p>' +
    '<p>●お問い合わせ対応（本人への連絡を含む）のため</p>' +
    '<p>・当社のサービス向上のため</p>' +
    '<p>・本サービスに関連した、各種情報のご案内のため</p>' +
    '<p>●サービスの調査と、お知らせ（本人への連絡を含む）のため</p>' +
    '<p>・当社および当社が認めた者のアンケート等による調査のご案内のため</p>' +
    '<p>・当社および当社が認めた者の広告宣伝のため</p>' +
    '<h3>4. 個人情報取扱いの委託</h3>' +
    '<p>当社は事業運営上、前項利用目的の範囲に限って個人情報を外部に委託することがあります。この場合、個人情報保護水準の高い委託先を選定し、個人情報の適正管理・機密保持についての契約を交わし、適切な管理を実施させます。</p>' +
    '<h3>5. 個人情報の開示等の請求</h3>' +
    '<p>ご本人様は、当社に対してご自身の個人情報の開示等（利用目的の通知、開示、内容の訂正・追加・削除、利用の停止または消去、第三者への提供の停止）に関して、下記の当社問合わせ窓口に申し出ることができます。その際、当社はお客様ご本人を確認させていただいたうえで、合理的な期間内に対応いたします。</p>' +
    '<p class="mt-25">【お問合せ窓口】</p>' +
    '<p>E-mail： privacy@lecre.jp</p>' +
    '<p>〒107-0061 東京都港区北青山1-2-3 青山ビル3F</p>' +
    '<h3>6. 個人情報を提供されることの任意性について</h3>' +
    '<p>ご本人様が当社に個人情報を提供されるかどうかは任意によるものです。 ただし、必要な項目をいただけない場合、適切な対応ができない場合があります。</p>'
  }
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/terms.js